export abstract class InputHelper {
    public static integerOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    public static integerOnlyWithNegatives(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        //allow minus "-"
        if(charCode == 45){
            return true;
        }
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }
}